import {types} from '../../types';

const setGetListAdminAction = (payload) => {
  return {
    type: types.admin.SET_LIST_MOBILE,
    payload,
  }
}

const setGetListHistoryAction = (payload) => {
  return {
    type: types.admin.SET_HISTORY_MOBILE,
    payload,
  }
}

const setGetListEventsAction = (payload) => {
  return {
    type: types.admin.SET_EVENT_MOBILE,
    payload,
  }
}

export {
  setGetListAdminAction as SetGetListAdminAction,
  setGetListHistoryAction as SetGetListHistoryAction,
  setGetListEventsAction as SetGetListEventsAction
}